import { NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FuseLoadingBarComponent } from '@fuse/components/loading-bar';
import { DisplayErrorService } from 'app/core/display-error/display-error.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector     : 'empty-layout',
    templateUrl  : './empty.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone   : true,
    imports      : [FuseLoadingBarComponent, NgIf, RouterOutlet],
})
export class EmptyLayoutComponent implements OnDestroy, OnInit
{
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    displayError: {
        type: string,
        title: string;
        message: string;
    } = null;

    /**
     * Constructor
     */
    constructor(
        private _displayErrorService: DisplayErrorService,
        private _changeDetectorRef: ChangeDetectorRef
    )
    {
    }

    ngOnInit(): void {
        // Subscribe to show error
        this._displayErrorService.errorMessage$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((response) => {
                if (response) {
                    this.displayError = response;
                }
                // Mark for check
                this._changeDetectorRef.markForCheck();
            });

        this._displayErrorService.hide();
        this.displayError = null;
    }



    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
